// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import type { TFunction } from 'i18next';
import { type PerformanceLineChartFeature } from './performance-line-chart';

export const getPerformanceLineLabel = (id: string, feature: string): string => {
  if (feature === 'rebalance') {
    return id === 'PORTFOLIO' ? 'TARGET PORTFOLIO' : 'CURRENT PORTFOLIO';
  }
  return id;
};

export const getTranslatedChartLabel = (
  id: string,
  t: TFunction,
  feature?: PerformanceLineChartFeature,
) => {
  const translationMap = new Map([
    [
      'rebalance_TARGET PORTFOLIO',
      { key: 'backtest.target-portfolio', ns: 'components' },
    ],
    [
      'rebalance_CURRENT PORTFOLIO',
      { key: 'backtest.current-portfolio', ns: 'components' },
    ],
    [
      'general_BENCHMARK',
      { key: 'glossary.benchmark', ns: 'glossary', uppercase: true },
    ],
    [
      'general_PORTFOLIO',
      { key: 'glossary.portfolio', ns: 'glossary', uppercase: true },
    ],
  ]);

  const featureKey = feature ? `${feature}_${id}` : null;
  const generalKey = `general_${id}`;

  const config =
    translationMap.get(featureKey || '') || translationMap.get(generalKey);

  if (config) {
    const translated = t(config.key as any, { ns: config.ns as any });
    return config.uppercase ? translated.toUpperCase() : translated;
  }

  return id;
};
